module.exports = __webpack_public_path__ + "static/paczki_osobno_silver-ffb9e4dca55652873bd6192cf0895e05.png";